import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./AssistanceButton.css";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import assistanceIcon from "./call.png";
const AssistanceButton = () => {
  return (
    <a href="tel:+33 6 65 50 46 20" className="assistance-button">
      <img
        src={assistanceIcon}
        alt="Assistance"
        className="assistance-icon"
      />
    </a>
  );
};

export default AssistanceButton;
